import { Line } from '@react-three/drei'
import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import type { EstadoTetoLateral } from '../../dominio/didatico/rebatimentoLateralTeto'
import { pontosTetoLateral } from './zonasTetoLateral'
import { SerraSabre3D } from './SerraSabre3D'

function Machadinha3D({ progresso }: { progresso: number }) {
  const golpe = Math.sin(progresso * Math.PI * 8) * 0.32
  return <group rotation={[0, 0, golpe]} name="machadinha-corte-vidro">
    <mesh position={[0, 0.29, 0]}><cylinderGeometry args={[0.018, 0.023, 0.58, 12]} /><meshStandardMaterial color="#b87532" roughness={0.7} /></mesh>
    <mesh position={[0.02, 0, 0]}><boxGeometry args={[0.18, 0.075, 0.035]} /><meshStandardMaterial color="#cbd5e1" metalness={0.9} roughness={0.3} /></mesh>
    <mesh position={[0.10, -0.027, 0]} rotation={[0, 0, -0.25]}><boxGeometry args={[0.11, 0.02, 0.04]} /><meshStandardMaterial color="#f1f5f9" metalness={0.9} roughness={0.2} /></mesh>
    <mesh position={[0, 0.43, 0]}><cylinderGeometry args={[0.025, 0.025, 0.22, 12]} /><meshStandardMaterial color="#111827" roughness={0.85} /></mesh>
  </group>
}
export function CorteParabrisaTeto3D({ perfil, estado, ferramenta, progresso, visivel, afastamento = 0 }: {
  perfil: PerfilVeiculo; estado: EstadoTetoLateral; ferramenta: 'machadinha' | 'serraSabre' | null; progresso: number; visivel: boolean; afastamento?: number
}) {
  const p = pontosTetoLateral(perfil)
  const avanco = ferramenta === 'serraSabre' ? progresso : 0
  const contato = p.vidroInicio.map((n, i) => n + (p.vidroFim[i] - n) * avanco) as [number, number, number]
  const fimCorte = estado.vidroCortado ? p.vidroFim : contato
  return <group name="corte-parabrisa-teto">
    {(estado.vidroCortado || (ferramenta === 'serraSabre' && progresso > 0)) && <Line points={[p.vidroInicio, fimCorte]}
      color={ferramenta === 'serraSabre' ? '#f1d17a' : '#667483'}
      lineWidth={ferramenta === 'serraSabre' ? 3 : 1} />}
    {visivel && ferramenta && <group position={[contato[0], contato[1] + afastamento, contato[2] + 0.04]}>
      {ferramenta === 'machadinha' ? <Machadinha3D progresso={progresso} /> : <SerraSabre3D progresso={progresso} />}
    </group>}
  </group>
}
